<div class="govuk-width-container d-flex">
    <gb-ui-header
      [imageDetail]="imageDetail"
      [navLinks]="navigation"
      [showSearch]="true"
      [displayLinksBelow]="true"
      (searchTerm)="search($event)"
    >
      <ng-template #utilityArea>
        <div class="d-flex">
          @if (!isAdmin()) {
          <button class="btn btn-primary login" (click)="login()">
            Log in
          </button>
          }
        </div>
      </ng-template>
    </gb-ui-header>
  </div>
  